import { render, staticRenderFns } from "./CardPopover.vue?vue&type=template&id=7ca836e6&scoped=true&"
import script from "./CardPopover.vue?vue&type=script&lang=js&"
export * from "./CardPopover.vue?vue&type=script&lang=js&"
import style0 from "./CardPopover.vue?vue&type=style&index=0&id=7ca836e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca836e6",
  null
  
)

export default component.exports